<template>
  <div v-if="creditNote" class="row">
    <div class="col-12 col-xl-3">
      <document-settings :title="creditNote.number">
        <div slot="body">
          <div style="columns: 150px 3">
            <fg-input :label="$t('message.invoiceNumber')">
              <div class="d-inline-block w-100">
                <router-link
                  tag="a"
                  :to="`/invoices/view/${creditNote.invoiceId}`"
                >{{ creditNote.invoiceNumber }}</router-link>
              </div>
            </fg-input>
            <fg-input :label="$t('message.customer')">
              <div class="d-inline-block w-100">
                <router-link
                  tag="a"
                  :to="`/customers/view/${creditNote.to._id}`"
                >{{ creditNote.to.companyName }}</router-link>
              </div>
            </fg-input>
            <fg-input :label="$t('message.dateSent')">
              <div class="d-inline-block w-100">{{ creditNote.sentDate | dateToHuman }}</div>
            </fg-input>
            <fg-input :label="$t('message.creditNoteReason')">
              <div class="d-inline-block w-100">{{ creditNoteReasons[creditNote.reason].label }}</div>
            </fg-input>
            <fg-input
              v-if="creditNote.reason === 'REFUND' && creditNote.stripeChargeId"
              :label="$t('message.onlineRefundIssued')"
            >
              <div
                class="d-inline-block w-100"
              >{{ creditNote.refund.timestamp | dateToHumanWithTime }}</div>
            </fg-input>
          </div>
          <hr />
          <div>
            <n-button
              type="secondary"
              round
              simple
              @click.native.prevent="goBack('/credit-notes')"
            >{{ $t("message.goBack") }}</n-button>
          </div>
        </div>
      </document-settings>
    </div>
    <div class="col-12 col-xl-9">
      <document
        :title="$t('message.creditNote')"
        :header-items="headerItems"
        :from="creditNote.from"
        :to-label="$t('message.creditNoteCreditedTo')"
        :to="creditNote.to"
        :sub-total="creditNote.subTotal.displayValue"
        :vat-total="creditNote.vatTotal.displayValue"
        :total="creditNote.total.displayValue"
      >
        <template slot="table">
          <b-table :fields="tableFields" :items="creditNote.items" stacked="sm" striped></b-table>
        </template>
      </document>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import {
  dateToHuman,
  dateToHumanWithTime,
  formatMoney
} from "@/helpers/helpers.js";
import { goBack } from "@/mixins";
import { Document, DocumentSettings } from "@/components";

export default {
  mixins: [goBack],
  components: {
    Document,
    DocumentSettings
  },
  data() {
    return {
      loader: null,
      creditNoteReasons: {
        OVERPAYMENT: {
          id: "OVERPAYMENT",
          label: "Overpayment"
        },
        REFUND: {
          id: "REFUND",
          label: "Refund"
        },
        OTHER: {
          id: "OTHER",
          label: "Other"
        }
      },
      tableFields: [
        {
          key: "description",
          label: this.$t("message.invoiceItem")
        },
        {
          key: "price",
          label: this.$t("message.invoiceItemUnitCost") + " (€)"
        },
        {
          key: "quantity",
          label: this.$t("message.invoiceItemQuantity")
        },
        {
          key: "vat",
          label: this.$t("message.invoiceItemVat")
        },
        {
          key: "total",
          label: this.$t("message.invoiceItemPrice"),
          class: "text-sm-right",
          formatter: (value, key, item) =>
            formatMoney(item.price * item.quantity)
        }
      ]
    };
  },
  methods: mapActions(["fetchCreditNote"]),
  computed: {
    ...mapGetters(["creditNote"]),
    headerItems() {
      return [
        {
          label: this.$t("message.creditNoteNumber"),
          value: this.creditNote.number
        },
        {
          label: this.$t("message.invoiceNumber"),
          value: this.creditNote.invoiceNumber
        },
        {
          label: this.$t("message.dateSent"),
          value: dateToHuman(this.creditNote.sentDate)
        },
        {
          label: this.$t("message.dateDue"),
          value: this.creditNote.dueDate
        }
      ];
    }
  },
  filters: {
    dateToHuman,
    dateToHumanWithTime
  },
  created() {
    this.fetchCreditNote(this.$route.params.id);
  }
};
</script>
